export default "__VITE_ASSET__DOx4R3Se__"